// extracted by mini-css-extract-plugin
export default {"menu-item":"jPCG7","button":"sQQKz","menu-item-title":"pbha0","menu-item--selected":"vNbeF"};